import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { enviarCodigoVerificacion } from 'services/apiServices';
import { mfaErrorsSelector } from 'store/selectors';
import CardSmall from 'components/CardSmall';
import ButtonSection from 'components/ButtonSection';
import Snackbar from 'components/Snackbar';
import { DEFAULT_SNACKBAR_INFO } from 'constants/commonConstants';

import './emailMFACard.css';

const EmailMFACard = ({ title, desc, handleContinue, handleBack, uuid }) => {
  const styles = {
    'resend-button': { fontSize: '15px', color: '#003DA5' },
    containers: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      'max-width': '700px',
    },
    'code-title': { fontWeight: 'bold', color: 'darkblue' },
    error: { border: '2px solid #B60000' },
    'error-validacion': { fontSize: '15px', color: '#B60000' },
    'flex-end': { alignSelf: 'flex-end' },
  };
  const mfaErrors = useSelector(mfaErrorsSelector);
  const [value, setValue] = useState();
  const [colorResendSuccess, setColorResendSuccess] = useState(null);
  const [snackBarInfo, setSnackBarInfo] = useState(DEFAULT_SNACKBAR_INFO);
  const handleOcultarSnackbar = () => {
    setSnackBarInfo(DEFAULT_SNACKBAR_INFO);
  };
  return (
    <CardSmall style={styles.containers}>
      <div className="totp-card__title">{title}</div>
      <div className="totp-card__desc">{desc}</div>
      <div
        className="render-field-nuevo__input-div-container"
        style={styles.containers}
      >
        <span style={styles['code-title']}>
          Ingresá el código de verificación
        </span>
        <input
          style={mfaErrors ? styles.error : null}
          value={value}
          placeholder="Ej. 123456"
          onChange={e => setValue(e.target.value)}
          inputMode="numeric"
        />
        {mfaErrors && (
          <span style={styles['error-validacion']}>{mfaErrors}</span>
        )}
        <button
          type="button"
          onClick={async () => {
            await enviarCodigoVerificacion(uuid);
            setColorResendSuccess('#009e3c');
            setTimeout(() => {
              setColorResendSuccess(null);
            }, 500);
            setSnackBarInfo({ mostrar: true, texto: 'Nuevo código enviado.' });
          }}
          style={{
            ...styles['resend-button'],
            color: colorResendSuccess || styles['resend-button'].color,
          }}
        >
          Reenviar código
        </button>
      </div>
      <div style={styles['flex-end']}>
        <ButtonSection
          handleClickPrimary={() => handleContinue(value)}
          textPrimary="Confirmar activación 2FA"
          handleClickSecondary={!uuid && handleBack}
          textSecondary={!uuid && 'Modificar correo electrónico'}
          isVertical
        />
      </div>
      <Snackbar
        desplegar={snackBarInfo.mostrar}
        mensaje={snackBarInfo.texto}
        onClose={handleOcultarSnackbar}
      />
    </CardSmall>
  );
};

EmailMFACard.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  handleContinue: PropTypes.func,
  handleBack: PropTypes.func,
  uuid: PropTypes.string,
};

export default EmailMFACard;
